import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { apiService } from '../../services/apiService';
import { useParams } from 'react-router-dom';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box } from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';

function KbAcessGroup() {
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [loading2, setLoading2] = useState(false);
    const [kbAccessData, setKbAccessData] = useState([]);
    const [kbSummary, setKbSummary] = useState([]);
    const [paginatedata2, setPaginateData2] = useState({});
    const [currentPage2, setCurrentPage2] = useState(1);
    const [selectedRecord2, setShowRecord2] = useState(20);

    const [filter, setFilter] = useState("total_kbs");
        
    const fetchKbAccessData = useCallback(async (page = 1, per_page = selectedRecord2) => {
        setLoading2(true);
        try {
            const response = await apiService.postRequest(`/groups/${id}/kb-access`, {
                page,
                per_page,
                type: filter,
            });
            if (response && response.success) {
                setKbAccessData(response.data || []);
                setPaginateData2(response?.meta);
            } else {
                if (response && response.authenticate === false) {
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching group data:', error);
        } finally {
            setLoading(false);
            setLoading2(false);
        }
    }, [id, filter, selectedRecord2]);

    const handlePageChange2 = (newPage) => {
        setCurrentPage2(newPage);
        fetchKbAccessData(newPage);
    };

    // Runs on mount and whenever filter changes
    useEffect(() => {
        setCurrentPage2(1);
        fetchKbAccessData(1);
    }, [fetchKbAccessData]);

    const fetchKbAccessSummary = useCallback(async (params = {}) => {
        try {
            const response = await apiService.postRequest(`/groups/${id}/kb-access/summary`);
            if(response && response.success){
                setKbSummary(response?.data || []);
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching group data:', error);
        }
    }, [id]);
    useEffect(() => {
        fetchKbAccessSummary();
    }, [fetchKbAccessSummary]);

    const rows2 = kbAccessData.map((datas, index) => ({
        index: paginatedata2?.from + index,
        id: datas.kb_id,
        kbName: datas.kb_name,
        accessSource: datas.access_source || "No Data",
        total: datas?.article_counts?.total,
        draft: datas?.article_counts?.draft,
        published: datas?.article_counts?.published,
        under_approval: datas?.article_counts?.under_approval,
        retired: datas?.article_counts?.retired,
    }));
    const columns2 = [
        {
            field: 'index',
            headerName: 'S.No',
            minWidth: 150,
            flex: 1,
            filterable: false,
            sortable: false,
        },
        {
            field: 'kbName',
            headerName: 'KB Name',
            minWidth: 250,
            flex: 1,
            filterable: false,
            sortable: false,
        },
        {
            field: 'accessSource',
            headerName: 'Access Source',
            minWidth: 250,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100 margin_unsetavatar'>
                    <span><b className={params.row.accessSource === "Access Group"?'manager_groupshow':"manager_groupacees"}>{params.row.accessSource}</b></span>
                </div>
            ),
            flex: 1,
            filterable: false,
            sortable: false,
        },
        {
            field: 'total',
            headerName: 'Total',
            minWidth: 150,
            flex: 1,
            filterable: false,
            sortable: false,
        },
        {
            field: 'draft',
            headerName: 'Draft',
            minWidth: 150,
            flex: 1,
            filterable: false,
            sortable: false,
        },
        {
            field: 'published',
            headerName: 'Published',
            minWidth: 150,
            flex: 1,
            filterable: false,
            sortable: false,
        },
        {
            field: 'under_approval',
            headerName: 'Under Approval',
            minWidth: 150,
            flex: 1,
            filterable: false,
            sortable: false,
        },
        {
            field: 'retired',
            headerName: 'Retired',
            minWidth: 150,
            flex: 1,
            filterable: false,
            sortable: false,
        },
    ];
  return (
    <>
    {loading === true ?
        <div className='d-flex justify-content-center w-100' style={{minHeight:"30vh"}}>
            <img style={{ width: "100px", height: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
        </div> :
        <Grid size={{xs:12}} container className="mt-3 pb-3" style={{height:"fit-content"}}>
            <Grid size={{xs:12}} container className="gap-3 mb-4">
                <Grid size={{lg:2.8, md:2.8, xs:4}} container flexDirection="column" alignItems="center" onClick={() => setFilter("total_kbs")} className={`${ filter === "total_kbs" && "active_card"} record_cardkbaccess`}>
                    <h4>{kbSummary?.total_kbs || "0"}</h4>
                    <h6>Total KBs</h6>
                </Grid>
                <Grid size={{lg:2.8, md:2.8, xs:4}} container flexDirection="column" alignItems="center" onClick={() => setFilter("total_owned")} className={`${ filter === "total_owned" && "active_card"} record_cardkbaccess`}>
                    <h4>{kbSummary?.total_owned || "0"}</h4>
                    <h6>Owner Of</h6>
                </Grid>
                <Grid size={{lg:2.8, md:2.8, xs:4}} container flexDirection="column" alignItems="center" onClick={() => setFilter("total_shared")} className={`${ filter === "total_shared" && "active_card"} record_cardkbaccess`}>
                    <h4>{kbSummary?.total_shared || "0"}</h4>
                    <h6>Access Of</h6>
                </Grid>
                <Grid size={{lg:2.8, md:2.8, xs:4}} container flexDirection="column" alignItems="center" onClick={() => setFilter("total")} className={`${ filter === "total" && "active_card"} record_cardkbaccess`}>
                    <h4>{kbSummary?.grand_article_totals?.total || "0"}</h4>
                    <h6>Total Articles</h6>
                </Grid>
                <Grid size={{lg:2.8, md:2.8, xs:4}} container flexDirection="column" alignItems="center" onClick={() => setFilter("draft")} className={`${ filter === "draft" && "active_card"} record_cardkbaccess`}>
                    <h4>{kbSummary?.grand_article_totals?.draft || "0"}</h4>
                    <h6>Draft</h6>
                </Grid>
                <Grid size={{lg:2.8, md:2.8, xs:4}} container flexDirection="column" alignItems="center" onClick={() => setFilter("under_approval")} className={`${ filter === "under_approval" && "active_card"} record_cardkbaccess`}>
                    <h4>{kbSummary?.grand_article_totals?.under_approval || "0"}</h4>
                    <h6>Under Approval</h6>
                </Grid>
                <Grid size={{lg:2.8, md:2.8, xs:4}} container flexDirection="column" alignItems="center" onClick={() => setFilter("published")} className={`${ filter === "published" && "active_card"} record_cardkbaccess`}>
                    <h4>{kbSummary?.grand_article_totals?.published || "0"}</h4>
                    <h6>Published</h6>
                </Grid>
                <Grid size={{lg:2.8, md:2.8, xs:4}} container flexDirection="column" alignItems="center" onClick={() => setFilter("retired")} className={`${ filter === "retired" && "active_card"} record_cardkbaccess`}>
                    <h4>{kbSummary?.grand_article_totals?.retired || "0"}</h4>
                    <h6>Retired</h6>
                </Grid>
            </Grid>
            {loading2 === true ?
            <div className='d-flex justify-content-center w-100' style={{minHeight:"30vh"}}>
                <img style={{ width: "100px", height: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
            </div> :
            <Box sx={{ height: 650, width: '100%' }} className="datatable_jobpagi">
                <DataGrid
                    style={{minHeight:"200px"}}
                    rows={rows2}
                    columns={columns2}
                    disableSelectionOnClick
                    components={{ Toolbar: GridToolbar }}
                />
            </Box>}
            {kbAccessData?.length > 0 &&<>
            <Grid size={{xs:12}} container justifyContent="space-between" className="mt-3">
                <div className='d-flex justify-content-end align-items-center'>
                    <label className='me-2'>Showing records <b>{paginatedata2.from}</b>-<b>{paginatedata2.to}</b> out of <b>{paginatedata2.total}</b></label>
                </div>
                <div className='d-flex justify-content-end datatable_jobpagi align-items-center'>
                    <label className='me-2'>No. of Rows</label>
                    <select
                        label="Rows per page"
                        value={selectedRecord2 || 20}
                        onChange={(e) => {
                            const value = Number(e.target.value);
                            setShowRecord2(value);
                            setCurrentPage2(1);
                        }}
                        sx={{ mr: 2 }}
                    >
                        {[5, 10, 20, 50].map((size) => (
                            <option key={size} value={size}>{size}</option>
                        ))}
                    </select>
                </div>
            </Grid>
            <Grid size={{xs:12}} container justifyContent="center" className="mt-4 pagination_btn">
                <button className='arrowpaginate'
                    onClick={() => handlePageChange2(currentPage2 - 1)} 
                    disabled={currentPage2 === 1}>
                    <FontAwesomeIcon icon={faChevronLeft} />
                </button>
                {paginatedata2 && paginatedata2.last_page > 0 && (
                    <div className="pagination">
                        {(() => {
                        const totalPages = Math.max(1, paginatedata2.last_page);
                        const pages = [];

                        const start = Math.max(2, currentPage2 - 2);
                        const end = Math.min(totalPages - 1, currentPage2 + 2);

                        // Always show page 1
                        pages.push(
                            <button
                            key={1}
                            onClick={() => handlePageChange2(1)}
                            className={currentPage2 === 1 ? 'active' : ''}
                            >
                            1
                            </button>
                        );

                        // Ellipsis after page 1 if needed
                        if (start > 2) {
                            pages.push(<span key="start-ellipsis">...</span>);
                        }

                        // Middle pages
                        for (let i = start; i <= end; i++) {
                            pages.push(
                            <button
                                key={i}
                                onClick={() => handlePageChange2(i)}
                                className={currentPage2 === i ? 'active' : ''}
                            >
                                {i}
                            </button>
                            );
                        }

                        // Ellipsis before last page if needed
                        if (end < totalPages - 1) {
                            pages.push(<span key="end-ellipsis">...</span>);
                        }

                        // Always show last page (if more than 1)
                        if (totalPages > 1) {
                            pages.push(
                            <button
                                key={totalPages}
                                onClick={() => handlePageChange2(totalPages)}
                                className={currentPage2 === totalPages ? 'active' : ''}
                            >
                                {totalPages}
                            </button>
                            );
                        }

                        return pages;
                        })()}
                    </div>
                )}
                <button className='arrowpaginate'
                    onClick={() => handlePageChange2(currentPage2 + 1)} 
                    disabled={currentPage2 === paginatedata2.last_page}>
                    <FontAwesomeIcon icon={faChevronRight} />
                </button>
            </Grid></>}
        </Grid>
    }
    </>
  )
}

export default KbAcessGroup
